import {
    AdAsset,
    AdAssetFormatId,
    AdAssetLabelList,
    AdAssetTitleList,
    CustomItems,
    InitAdAsset,
    SingleItems,
} from "./common/AdAssetModel";
import React, {useEffect, useState} from "react";
import AdAssetPreview from "./AdAssetsPreviewParts";
import {apollo_useStyles,} from "../../../atom/Apollo_styles";
import {Card, CardContent, CardHeader, Grid} from "@material-ui/core";
import {ApolloBasicLabel} from "../../../molecule/Apollo_BaseItem";
import {concat} from 'lodash';
import {get_ms_asset_path} from "../../../atom/Apollo_links";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {BLANK, MSG, options_ms_button_label, RESULT_KBN} from "./common/CommonConst";
import {ApolloAxios} from "../../../atom/Apollo_ApiRequest3";

interface AdAssetsDetailProps {
    platformAccountId: number;
    assetId?: number;
    options?: Options;
}

interface Options {
    trackingParam?: string,
}

const AdAssetsDetail: React.FC<AdAssetsDetailProps> = ({platformAccountId, assetId, options}) => {

    // style
    const classes = apollo_useStyles();

    // useContext
    const {state: apolloContex} = React.useContext(ApolloContext);
    const {data: msg, setmsg} = React.useContext(ApolloMessage);

    // useState
    const [adAsset, setAdAsset] = useState<AdAsset>(InitAdAsset)

    // useEffect
    useEffect(() => {
        const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_asset_path}/${platformAccountId}/${assetId}`;
        const fetchData = async () => {
            await ApolloAxios.get(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                }
            ).then(response => {
                if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                    setAdAsset(response.data.adAsset)
                } else {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ADASSET}${response?.data?.message ?? BLANK}`
                        }
                    });
                }
            }).catch(err => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_ADASSET}${err?.errmsg ?? BLANK}`
                    }
                });
            });
        };
        fetchData();
        /*        setAdAsset(testAdAsset);*/
    }, [])

    // etc
    const formatId = adAsset.mailData.commonItems.formatId

    // dispItem1
    const firstItems = [
        {
            labelName: AdAssetLabelList.assetName,
            text: adAsset.mailData.commonItems.assetName,
        },
        {
            labelName: AdAssetLabelList.subject,
            text: adAsset.mailData.commonItems.subject,
        },
    ]


    // dispItem2(single or custom)
    const secondItems =
        concat(formatId === AdAssetFormatId.single ?
                GetSingleItems(adAsset.mailData.singleItems, options) : GetCustomItems(adAsset.mailData.customItems, options)
            , {
                title: AdAssetTitleList.linkButton,
                items: [
                    {
                        name: AdAssetLabelList.buttonLabel,
                        text: getLabelName(adAsset.mailData.commonItems.buttonLinkItem.labelType)
                    },
                    {
                        name: AdAssetLabelList.transitionUrl,
                        text: JoinTrackingParamAndUrl(adAsset.mailData.commonItems.buttonLinkItem.transitionUrl, options?.trackingParam),
                    }
                ]
            }
        )
    // dispItem3
    const thirdItems = [
        {
            labelName: AdAssetLabelList.notation,
            text: adAsset.mailData.commonItems.notation,
        },
    ]

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Card className={classes.root} square variant="outlined">
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={7} className={classes.msPreviewText}>
                                {
                                    firstItems.map((item) => {
                                        return (
                                            <Grid container spacing={3}>
                                                <ApolloBasicLabel label={item.labelName} value={item.text}/>
                                            </Grid>
                                        )
                                    })
                                }
                                {
                                    secondItems.map((item: any) => {
                                        return (<CardContents title={item.title} items={item.items}/>)
                                    })
                                }
                                {
                                    thirdItems.map((item) => {
                                        return (
                                            <Grid container spacing={3}>
                                                <ApolloBasicLabel label={item.labelName} value={item.text}/>
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                            <Grid item xs={5}>
                                {/*<div style={{overflow: "auto", height: "100%", position: "absolute"}}>*/}
                                <div style={{overflow: "auto", height: "100%", position: "relative"}}>
                                    <AdAssetPreview {...adAsset} />
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

const CardContents: React.FC<{
    title: string,
    items: { name: string, text: string }[],
}> = ({title, items}) => {

    const classes = apollo_useStyles();

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Card className={classes.root}>
                        <CardHeader
                            style={{backgroundColor: "#EEE", padding: "3px", marginLeft: "5px"}}
                            title={title}
                            titleTypographyProps={{variant: "h6"}}
                        />
                        <CardContent>
                            {items.map((value, index) => {
                                return (
                                    <Grid container>
                                        <ApolloBasicLabel
                                            label={value.name}
                                            value={value.text}
                                        />
                                    </Grid>
                                )
                            })
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

const setButtonLinkImageState = (imageName: string) => {
    let ret = {color: "", label: "",}
    const imageNameParts = imageName.split("/")
    if (imageNameParts.length >= 3) {
        ret.color = imageNameParts[imageNameParts.length - 1][0]
        ret.label = imageNameParts[imageNameParts.length - 2]
    }
    return ret
}

const getLabelName = (labelType: string) => {
    const linkButtonLabelOptions = options_ms_button_label.find(item => item.value === labelType)
    return linkButtonLabelOptions ? linkButtonLabelOptions.label : ""
}

const JoinTrackingParamAndUrl = (url: string, trackingParam: string | undefined) => {

    return url ?
        `${url}${trackingParam ? url.includes("?") ? "&" : "?" : ""}${trackingParam ? trackingParam : ""}`
        : ""
}

const GetSingleItems = (singleItems: SingleItems, options: Options | undefined) => {

    return (
        [
            {
                title: AdAssetTitleList.image,
                items: [
                    {
                        name: AdAssetLabelList.imageFilename,
                        text: singleItems.imageItem.imageName
                    },
                    {
                        name: AdAssetLabelList.transitionUrl,
                        text: JoinTrackingParamAndUrl(singleItems.imageItem.transitionUrl, options?.trackingParam)
                    },],
            },
            {
                title: AdAssetTitleList.textLink1,
                items: [
                    {
                        name: AdAssetLabelList.text,
                        text: singleItems.textLinkItem1.text,
                    },
                    {
                        name: AdAssetLabelList.transitionUrl,
                        text: JoinTrackingParamAndUrl(singleItems.textLinkItem1.transitionUrl, options?.trackingParam),
                    },],
            },
            {
                title: AdAssetTitleList.textLong,
                items: [
                    {
                        name: AdAssetLabelList.text,
                        text: singleItems.textItem.text,
                    },],
            },
            {
                title: AdAssetTitleList.textLink2,
                items: [
                    {
                        name: AdAssetLabelList.text,
                        text: singleItems.textLinkItem2.text,
                    },
                    {
                        name: AdAssetLabelList.transitionUrl,
                        text: JoinTrackingParamAndUrl(singleItems.textLinkItem2.transitionUrl, options?.trackingParam),
                    },],
            },
        ]
    )
}

const GetCustomItems = (customItems: CustomItems, options: Options | undefined) => {

    return (
        customItems.sectionItems.map((item, index) => {
            const sectionNo = index + 1;
            return (
                {
                    title: `${AdAssetTitleList.section}${sectionNo}`,
                    items: [
                        {
                            name: AdAssetLabelList.imageFilename,
                            text: item.imageName,
                        },
                        {
                            name: `${AdAssetLabelList.textSecShort}${sectionNo}`,
                            text: item.shortText,
                        },
                        {
                            name: `${AdAssetLabelList.textSecLong}${sectionNo}`,
                            text: item.largeText,
                        },
                        {
                            name: `${AdAssetLabelList.textSecLink}${sectionNo}`,
                            text: item.textLink,
                        },
                        {
                            name: `${AdAssetLabelList.transitionUrl}`,
                            text: JoinTrackingParamAndUrl(item.transitionUrl, options?.trackingParam),
                        },
                    ],
                }
            )
        })
    )
}

export default AdAssetsDetail